module.exports = __webpack_public_path__ + "static/media/etherum.4fd59ead.png";